import React from 'react';

const PILLARS = [
  {
    eyebrow: 'Konsolidasyon',
    title: 'Tüm kanallar, tek ekran.',
    body: 'Onlarca panel, tek bir hikâye. Reklam platformları, analitik araçları, mobil atfetme ve veri ambarı — hepsi aynı dilden konuşur.',
    icons: [
      { src: '/google_ads-512.webp',     alt: 'Google Ads' },
      { src: '/6033716.png',             alt: 'Meta Ads' },
      { src: '/tik-tokiconss.png',       alt: 'TikTok Ads' },
      { src: '/pinterestlogopng.png',    alt: 'Pinterest' },
      { src: '/CRcriteopng.png',         alt: 'Criteo' },
      { src: '/RTBhouseiconPNG.png',     alt: 'RTB House' },
      { src: '/GA4logoicon.svg',         alt: 'Google Analytics 4' },
      { src: '/logo_search_consolev44.svg', alt: 'Search Console' },
      { src: '/adjustlogo.png',          alt: 'Adjust' },
      { src: '/merchantcenterlogo.svg',  alt: 'Merchant Center' },
    ],
  },
  {
    eyebrow: 'Şeffaflık',
    title: 'Marka ve ajans aynı tabloyu görür.',
    body: 'Ham veri tek noktada birikir. Performans rakamları talep edilen rapora değil, kaynağa bağlıdır.',
  },
  {
    eyebrow: 'Hız',
    title: 'Günde iki saat geri kazandırır.',
    body: 'Excel\'siz, Looker\'sız, gecikme yok. Hızlı ve sonuç odaklı raporlar — kopyalama, yapıştırma, slayt çıkarma değil; doğrudan eyleme yön veren paneller.',
  },
  {
    eyebrow: 'İstihbarat',
    title: 'Pazarı senden iyi kimse tanıyamaz.',
    body: 'Rakiplerin yayında olan reklamları, kanal kreatif takibi, kategori bazlı arama eğilimleri ve Türkiye\'ye özel pazarlama takvimi. Sezon başlamadan ne yapacağını bilirsin.',
    chips: [
      'Meta Ads Library',
      'Google Ads Transparency',
      'YouTube Radar',
      'TikTok Radar',
      'Pinterest Takip',
      'Google Trends',
      'Merchant Insights',
      'Marketing Holiday Planner',
    ],
  },
  {
    eyebrow: 'Otomasyon',
    title: 'Hiç kapanmaz.',
    body: 'Smart Campaign Engine kurallarla çalışır. ROAS düşerse bütçe daralır, en iyi kreatif ayakta kalır, anomaliler anında bildirilir.',
  },
  {
    eyebrow: 'Akıl',
    title: 'Veriniz ile sohbet edin.',
    body: 'GlowyAI; markanı tanıyan, geçmişini hatırlayan, doğru kanaldan doğru rakamı çeken — bir araç değil, bir asistan.',
  },
];

export default function WhyGlowytics() {
  return (
    <div className="min-h-screen bg-white text-gray-900 antialiased font-sans">
      {/* Top brand mark */}
      <div className="pt-10 pb-6 text-center">
        <div className="inline-block text-[11px] uppercase tracking-[0.25em] text-gray-500 font-medium">
          Glowytics
        </div>
      </div>

      {/* Hero */}
      <section className="px-6 md:px-12 pt-12 md:pt-20 pb-24 md:pb-32 max-w-5xl mx-auto text-center">
        <h1 className="text-5xl md:text-7xl lg:text-[5.5rem] font-semibold tracking-[-0.04em] leading-[0.95] text-gray-900">
          Pazarlama,
          <br />
          <span className="text-gray-400">netleşince</span> büyür.
        </h1>
        <p className="mt-10 text-xl md:text-2xl text-gray-500 max-w-2xl mx-auto leading-[1.4] font-normal tracking-tight">
          Glowytics, marka pazarlama ekiplerinin her gün karşılaştığı kaosu — onlarca panel, dağınık rapor, kaybolmuş veri — tek bir net resme dönüştürür.
        </p>
      </section>

      {/* Section divider */}
      <div className="px-6 md:px-12">
        <div className="max-w-5xl mx-auto h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />
      </div>

      {/* Vision statement */}
      <section className="px-6 md:px-12 py-24 md:py-32 max-w-4xl mx-auto text-center">
        <div className="text-[11px] uppercase tracking-[0.25em] text-gray-400 font-medium mb-6">
          Yola çıkış sebebi
        </div>
        <h2 className="text-3xl md:text-5xl font-semibold tracking-[-0.03em] leading-[1.1] text-gray-900">
          Veri çoktu. <span className="text-gray-400">Karar zordu.</span> Bir tane net partner gerekiyordu.
        </h2>
      </section>

      {/* Pillars — Apple-style alternating sections */}
      <section className="px-6 md:px-12 pb-12 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-20 md:gap-y-28">
          {PILLARS.map((p, i) => (
            <div key={i} className="group">
              <div className="text-[11px] uppercase tracking-[0.2em] text-gray-400 font-medium mb-4">
                {String(i + 1).padStart(2, '0')} · {p.eyebrow}
              </div>
              <h3 className="text-3xl md:text-4xl font-semibold tracking-[-0.025em] leading-[1.1] text-gray-900">
                {p.title}
              </h3>
              <p className="mt-5 text-lg text-gray-500 leading-[1.5] tracking-tight">
                {p.body}
              </p>
              {p.icons && p.icons.length > 0 && (
                <div className="mt-7 flex flex-wrap items-center gap-x-5 gap-y-3">
                  {p.icons.map((ic, j) => (
                    <img
                      key={j}
                      src={ic.src}
                      alt={ic.alt}
                      title={ic.alt}
                      className="h-7 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity duration-200"
                      loading="lazy"
                    />
                  ))}
                </div>
              )}
              {p.chips && p.chips.length > 0 && (
                <div className="mt-7 flex flex-wrap gap-2">
                  {p.chips.map((label, j) => (
                    <span
                      key={j}
                      className="px-3 py-1 rounded-full border border-gray-200 text-[12px] text-gray-600 tracking-tight font-medium hover:border-gray-300 hover:text-gray-900 transition-colors duration-200"
                    >
                      {label}
                    </span>
                  ))}
                </div>
              )}
              <div className="mt-8 h-px w-12 bg-gray-900 group-hover:w-24 transition-all duration-500" />
            </div>
          ))}
        </div>
      </section>

      {/* Closing */}
      <section className="px-6 md:px-12 py-32 md:py-48 max-w-5xl mx-auto text-center">
        <div className="text-[11px] uppercase tracking-[0.25em] text-gray-400 font-medium mb-8">
          Sonuç
        </div>
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-semibold tracking-[-0.04em] leading-[0.98] text-gray-900">
          Pazarlama ekibinin
          <br />
          <span className="text-gray-400">gerçek</span> partneri.
        </h2>
        <p className="mt-10 text-lg md:text-xl text-gray-500 max-w-2xl mx-auto leading-[1.5] tracking-tight">
          Veriyi tablodan eyleme çeviren, ajansla aynı dili konuşan, gece bile sahanın içinde olan — sade ama eksiksiz bir sistem.
        </p>
      </section>

      {/* Footer minimal */}
      <footer className="px-6 md:px-12 pb-12 border-t border-gray-100">
        <div className="max-w-6xl mx-auto pt-10 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-xs text-gray-400 tracking-wide">
            © {new Date().getFullYear()} Glowytics · Türkiye'de tasarlandı.
          </div>
          <div className="text-xs text-gray-400 tracking-wide">
            glowytics.com
          </div>
        </div>
      </footer>
    </div>
  );
}
